import { render } from "./matcherThresholds.vue?vue&type=template&id=8094988e"
import script from "./matcherThresholds.vue?vue&type=script&lang=js"
export * from "./matcherThresholds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__